export const preProcessPayload = (payload: any) => {
    // Trim onto the copy. The previous version wrote the trimmed value back onto
    // `payload` — usePagination's state object — *after* copying it, so the
    // request carried the untrimmed term and the state was mutated in place.
    const processedPayload: any = {
        ...payload,
    };
    processedPayload.searchText = payload?.searchText
        ? String(payload.searchText).trim()
        : '';
    return processedPayload;
};
export const HUB_MANAGEMENT_TABLE_COLUMNS = [
    {
        name: 'Hub Name',
        mappingKey: 'name',
        minWidth: 170,
    },
    {
        name: 'City',
        mappingKey: 'cityName',
        minWidth: 120,
    },
    {
        name: 'Shifts',
        mappingKey: 'shiftCount',
        width: '30%',
    },
    {
        name: 'Riders Active',
        mappingKey: 'staffCount',
        minWidth: 110,
        align: 'center',
    },
    {
        name: 'Vendors Active',
        mappingKey: 'activeVendorsCount',
        minWidth: 110,
        align: 'center',
    },
    {
        name: 'Store ID',
        mappingKey: 'bluedartUniqueStoreId',
        minWidth: 110,
    },

    {
        name: '',
        mappingKey: 'action',
        actions: true,
    },
];
